// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import indexActivities from 'actions/activity/index';
import indexPhases from 'actions/phase/index';
import indexProjectGroup from 'actions/project-group/index';
import indexProject from 'actions/project/index';
import storeProject from 'actions/project/store';
import indexTheme from 'actions/theme/index';
import indexSkills from 'actions/skill/index';
import FilterMenu from 'components/Layout/FilterMenu/FilterMenu';
import Layout from 'components/Layout/Layout';
import Button from 'components/UI/Button/Button';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import ProjectCard from 'components/UI/ProjectCard/ProjectCard';
import SharecodeInput from 'components/UI/SharecodeInput/SharecodeInput';
import Title from 'components/UI/Title/Title';
import { useAlert } from 'hooks/useAlert';
import { useFilter } from 'hooks/useFilter';
// import { useMediaQ } from 'hooks/useMediaQ';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect } from 'react';
import { optionsFilter, searchFilter } from 'utilities/filters';
import Invite from './Invite/Invite';
import './MyProjects.module.scss';
// =========================

export default function MyProjects() {
  const dispatch = useReduxAction();
  const translate = useTranslate();

  const isExtern = usePermission(['Extern']);

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexProject());
    dispatch(indexProjectGroup());
    dispatch(indexActivities());
    dispatch(indexPhases());

    if (isExtern) {
      dispatch(indexSkills());
    }
  }, []);

  // Filter logic
  const { filterValues, setFilterValues, initial } = useFilter('projects');

  const f1 = searchFilter(filterValues[0].value as string);
  const f2 = optionsFilter(filterValues[1].value as number[], 'categories');
  //

  const themesWithProject = useThemesWithProject([f1, f2]);

  // const query = useMediaQ('min', 1024);

  const themes = themesWithProject.filter((t) => !t?.project?.completed);

  const completedThemes = themesWithProject.filter(
    (t) => !!t?.project?.completed
  );

  const invites = useRedux((state) =>
    state.projectGroup?.entities.allIds
      .map((id) => state.projectGroup?.entities.byId[id])
      .filter((group) => group?.membership === 'invited')
      .reverse()
  );

  const alert = useAlert();

  function handleShareCodeSubmit(value: string) {
    dispatch(
      storeProject({
        fromShare: true,
        shareCode: value,
      })
    )
      .then(() => {
        dispatch(indexTheme());
        dispatch(indexProject());
      })
      .catch(() => {
        alert(translate('project.errors.could-not-add-project'));
      });
  }

  const loading = useRedux(
    (state) =>
      state.theme?.loading ||
      state.project?.loading ||
      state.projectGroup?.loading ||
      state.activity?.loading ||
      state.phase?.loading
  );

  return (
    <Layout
      filter={
        isExtern ? null : (
          <FilterMenu
            filterValues={filterValues.filter(
              (f) =>
                f.name !== translate('project.publication-popups.bron-settings')
            )}
            setFilterValues={setFilterValues}
            initial={initial}
          />
        )
      }
    >
      <NoContent
        page="my-projects"
        loading={!!loading}
        hasContent={themesWithProject.length > 0 || invites?.length! > 0}
        sharecode={<SharecodeInput handleSubmit={handleShareCodeSubmit} />}
      >
        <Container>
          <Title
            text={`${
              isExtern
                ? 'general.terms.follow-projects'
                : 'general.terms.my-projects'
            }`}
            loading={loading}
          />
          <div styleName="top">
            {/* {query && ( */}
            {!isExtern && (
              <Button to="/werkplaats/thema-bouwer">
                {translate('project.actions.create-project')}
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            )}
            {/* )} */}
            <SharecodeInput handleSubmit={handleShareCodeSubmit} />
          </div>
          <div styleName="page-wrapper">
            <div styleName="wrapper">
              {invites?.map(
                (invite) =>
                  !!(invite?.invitation && invite.project) && (
                    <div key={invite?.id}>
                      <Invite
                        type="project"
                        user={invite.invitation}
                        id={invite.id}
                        themeId={invite.project.theme_id}
                      />
                    </div>
                  )
              )}
              {!!themes.length && (
                <>
                  {themes?.map((theme) => (
                    <div key={theme?.id}>
                      <ProjectCard theme={theme} />
                    </div>
                  ))}
                </>
              )}
            </div>
            {!!completedThemes.length && (
              <>
                <h1>{translate('project.completed-projects')}</h1>
                <div styleName="wrapper">
                  {completedThemes?.map((theme) => (
                    <div key={theme?.id}>
                      <ProjectCard theme={theme} completed />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </Container>
      </NoContent>
    </Layout>
  );
}
